<template>
    <div>
        <div class="row mb-3">
            <div class="col-md-12">
                <router-link :to="'/worker/disclosures'" class='btn btn-normal float-right'>
                    Voltar
                </router-link>
            </div>
        </div>
        <dimension-charts v-if="research" :research="research" />    
        <div class="row mt-3 mb-5">
            <div class="col-md-12">
                <router-link :to="'/worker/disclosures'" class='btn btn-normal float-right'>
                    Voltar
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import DimensionCharts from '../Reusable/DimensionCharts'
export default {
    data() {
        return {
            research: null
        };
    },
    computed: {},
    methods: {
        getResearch() {
            const self = this
            const api = self.$store.state.api + "researches/dash-home/" + self.$route.params.id
            self.$http
                .get(api)
                .then(response => {
                    self.research = response.data
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error")
                });
        }
    },
    mounted: function() {
        this.getResearch();
    },
    components: {
        DimensionCharts
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Disclosure/Graphs.vue